/** Replaceable placeholder imagery for store profile mock-up */

export const MOCK_IMAGES = {
  storefront: 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?w=1200&h=600&fit=crop',
  storefrontHero: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=1600&h=800&fit=crop',
  entrance: 'https://images.unsplash.com/photo-1607082348824-0a960f851aae?w=800&h=600&fit=crop',
  checkout: 'https://images.unsplash.com/photo-1601593346740-925612772716?w=800&h=600&fit=crop',
  aisle: 'https://images.unsplash.com/photo-1583258292688-d0213dc5a3a8?w=800&h=600&fit=crop',
  chill: 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?w=800&h=600&fit=crop',
  frozen: 'https://images.unsplash.com/photo-1607623814075-048ad9a5d8c0?w=800&h=600&fit=crop',
  promotional: 'https://images.unsplash.com/photo-1607082349566-187342175e2f?w=800&h=600&fit=crop',
  loading: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&h=600&fit=crop',
  mediaFin: 'https://images.unsplash.com/photo-1607082348824-0a960f851aae?w=600&h=800&fit=crop',
  mediaShelf: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d4046?w=600&h=800&fit=crop',
  mediaFloor: 'https://images.unsplash.com/photo-1607082349566-187342175e2f?w=800&h=600&fit=crop',
  panoramic: 'https://images.unsplash.com/photo-1583258292688-d0213dc5a3a8?w=1920&h=1080&fit=crop',
  walkthroughThumb: 'https://images.unsplash.com/photo-1607082348824-0a960f851aae?w=640&h=360&fit=crop',
  mapPlaceholder: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=600&h=400&fit=crop',
} as const;
